import { defineStore } from "pinia";
import { precargaCombos } from "@/services/ofertaPrecarga.js";
import { formatMonthRange } from "@/services/date";

const filtrosDisponibles = [
  "unidadesNegocio",
  "clienteId",
  "paises",
  "estados",
  "fecha",
  "busqueda",
  "sectores",
  "fechaOferta",
  "primeraVersion",
  "campanias",
  "origenes",
  "propietarios",
  "tiposDeVenta",
  "embudos",
  "etapas",
  "estadosPipedrive",
  "fechaFirmaContrato",
  "planes",
  "tarifas",
];

function filtrosNuevos() {
  return {
    clienteId: 0,
    fecha: "",
    busqueda: "",
    fechaOferta: "",
    fechaPrimeraVersion: "",
    fechaFirmaContrato: "",
    unidadesNegocio: [],
    paises: [],
    estados: [],
    sectores: [],
    campanias: [],
    origenes: [],
    propietarios: [],
    tiposDeVenta: [],
    embudos: [],
    etapas: [],
    estadosPipedrive: [],
    planes: [],
    tarifas: [],
  };
}

export const useFiltrosOfertaFormStore = defineStore("FiltrosOfertaForm", {
  state() {
    return {
      filtros: filtrosNuevos(),
      maestros: {
        clientes: [],
        unidadesNegocio: [],
        paises: [],
        propietarios: [],
        tiposDeVenta: [],
        origenes: [],
        embudos: [],
        etapas: [],
        estadosPipedrive: [],
        campanias: [],
        estados: [],
        sectores: [],
        planes: [],
        tarifas: [],
      },
    };
  },
  getters: {
    filtrosUsados() {
      const usados = this.determinarFiltrosUsados();
      return usados.join(", ").replace(/,([^,]*)$/, " y$1");
    },
    mostrarFiltrosUsados() {
      const usados = this.determinarFiltrosUsados();
      return usados.length > 0;
    },
    filtrosAplicables() {
      const params = Object.assign({}, this.filtros);
      const rango = formatMonthRange(this.filtros.fecha);

      if (rango) {
        params.fechaDesde = rango[0];
        params.fechaHasta = rango[1];
      }

      const rangoOferta = formatMonthRange(this.filtros.fechaOferta);
      if (rangoOferta) {
        params.fechaOfertaDesde = rangoOferta[0];
        params.fechaOfertaHasta = rangoOferta[1];
      }

      const rangoPrimeraVersion = formatMonthRange(this.filtros.fechaPrimeraVersion);
      if (rangoPrimeraVersion) {
        params.fechaPrimeraVersionDesde = rangoPrimeraVersion[0];
        params.fechaPrimeraVersionHasta = rangoPrimeraVersion[1];
      }

      const rangoFechaFirma = formatMonthRange(this.filtros.fechaFirmaContrato);
      if (rangoFechaFirma) {
        params.fechaFirmaContratoDesde = rangoFechaFirma[0];
        params.fechaFirmaContratoHasta = rangoFechaFirma[1];
      }

      return params;
    },
    opcionesCliente() {},
  },
  actions: {
    setFiltros(filtros) {
      for (const key of filtrosDisponibles) {
        if (key in filtros) {
          this.filtros[key] = filtros[key];
        }
      }
    },
    determinarFiltrosUsados() {
      let usados = [];

      if (this.filtros.clienteId > 0) {
        usados.push("cliente");
      }
      if (this.filtros.unidadesNegocio.length > 0) {
        usados.push("unidades de negocio");
      }
      if (this.filtros.paises.length > 0) {
        usados.push("paises");
      }
      if (this.filtros.fecha) {
        usados.push("fecha");
      }
      if (this.filtros.fechaOferta) {
        usados.push("fecha de oferta");
      }
      if (this.filtros.primeraVersion) {
        usados.push("Fecha de primera versión");
      }
      if (this.filtros.fechaFirmaContrato) {
        usados.push("Fecha de firma");
      }
      if (this.filtros.busqueda) {
        usados.push("búsqueda");
      }
      if (this.filtros.estados.length > 0) {
        usados.push("estado");
      }
      if (this.filtros.campanias.length > 0) {
        usados.push("campaña");
      }
      if (this.filtros.tiposDeVenta.length > 0) {
        usados.push("tipo de venta");
      }
      if (this.filtros.origenes.length > 0) {
        usados.push("origen");
      }
      if (this.filtros.propietarios.length > 0) {
        usados.push("propietario");
      }
      if (this.filtros.embudos.length > 0) {
        usados.push("embudo");
      }
      if (this.filtros.etapas.length > 0) {
        usados.push("etapa");
      }
      if (this.filtros.estadosPipedrive.length > 0) {
        usados.push("estado en pipedrive");
      }
      if (this.filtros.sectores.length > 0) {
        usados.push("sectores");
      }
      if (this.filtros.planes.length > 0) {
        usados.push("planes");
      }
      if (this.filtros.tarifas.length > 0) {
        usados.push("tarifas");
      }

      return usados;
    },
    actualizarFiltrosAplicables() {
      return this.cargarMaestros();
    },
    limpiarFiltros() {
      this.filtros = filtrosNuevos();
    },
    async cargarMaestros() {
      const datos = await precargaCombos(this.filtrosAplicables);
      this.maestros.unidadesNegocio = datos.unidadesNegocio;
      this.maestros.paises = datos.paises;
      this.maestros.propietarios = datos.propietarios;
      this.maestros.tiposDeVenta = datos.tiposDeVenta;
      this.maestros.origenes = datos.origenes;
      this.maestros.embudos = datos.embudos;
      this.maestros.etapas = datos.etapas;
      this.maestros.estadosPipedrive = datos.estadosPipedrive;
      this.maestros.campanias = datos.campanias;
      this.maestros.estados = datos.estados;
      this.maestros.sectores = datos.sectores;
      this.maestros.planes = datos.planes;
      this.maestros.tarifas = datos.tarifas;
    },
  },
});
